// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1vFz1","label":"CategoryService_label__2o6og","location":"CategoryService_location__3Jm-6"};